exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label[data-v-3712ba15]{position:absolute;top:0;left:1.125rem;transform:translateY(1.125rem);font-size:1.125rem;color:#6e6e6e;font-weight:400;transition:.2s ease-out;z-index:2;cursor:pointer}label.active[data-v-3712ba15]{color:#16244f;font-size:.75rem;transform:translateY(8px)}label.error[data-v-3712ba15]{color:#c52d00}label.disabled[data-v-3712ba15]{color:#6e6e6e;cursor:default}", ""]);

// exports
